import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';

const styles = {};

const enhance = compose();

const Pagination = enhance(
  ({
    hidden,
    searchResults,
    rowsPerPage,
    page,
    totalCount,
    handleChangePage,
    handleChangeRowsPerPage
  }) => {
    return (
      <div>
        <TablePagination
          hidden={hidden}
          rowsPerPageOptions={[5, 25, 100]}
          component="div"
          count={totalCount || (searchResults ? searchResults.length : 0)}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page'
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page'
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Pagination));
